import { render } from "./ComplianceInvoicesComponent.vue?vue&type=template&id=da97a6f2&scoped=true"
import script from "./ComplianceInvoicesComponent.vue?vue&type=script&lang=js"
export * from "./ComplianceInvoicesComponent.vue?vue&type=script&lang=js"

import "./ComplianceInvoicesComponent.vue?vue&type=style&index=0&id=da97a6f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da97a6f2"]])

export default __exports__